// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".delete--btn[data-v-13948129] {\n  max-width: 8% !important;\n  min-width: initial !important;\n  margin-left: 2rem;\n  color: rgba(0, 0, 0, 0.54);\n}", ""]);
// Exports
module.exports = exports;
